import { useEffect, useRef } from 'react';

/**
 * Calls `onVisible` when scrolled into view. Re-key it on each loaded page so
 * it fires again when it is still visible after the page renders.
 */
export default function LoadMoreSentinel({ onVisible }: { onVisible: () => void }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) onVisible();
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [onVisible]);

  return (
    <div ref={ref} className="d-flex justify-content-center py-2">
      <div className="spinner-border spinner-border-sm text-secondary" />
    </div>
  );
}
